module.exports = __webpack_public_path__ + "static/media/error.c789c83d.png";